import { render } from "./bmdetail.vue?vue&type=template&id=2d4984b0&scoped=true"
import script from "./bmdetail.vue?vue&type=script&lang=js"
export * from "./bmdetail.vue?vue&type=script&lang=js"

import "./bmdetail.vue?vue&type=style&index=0&id=2d4984b0&lang=scss&scoped=true"
import "./bmdetail.vue?vue&type=style&index=1&id=2d4984b0&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d4984b0"]])

export default __exports__